module.exports = __webpack_public_path__ + "img/authBgx.5c945937.png";